import { GlobalStyles as MuiGlobalStyles, type Theme } from "@schaeffler-commerce/design-system";

export const printStyles = (theme: Theme) => ({
  ".scha__print-only": {
    display: "none",
  },
  "@media print": {
    html: {
      fontSize: "10px",
    },
    "*": {
      WebkitPrintColorAdjust: "exact !important",
      printColorAdjust: "exact !important",
    },
    "@page": {
      size: "A4",
      margin: "11mm 17mm 17mm 17mm",
    },
    ".scha__print-only": {
      display: "block",
    },
    ".scha__screen-only": {
      display: "none !important",
    },
    "html, body": {
      width: "100%",
    },
    // Migrated from style.less' print block: copy of the desktop-s container
    // width (@container-desktop-s = 1208px). The style.less `@page
    // 330mm 427mm / margin 14mm` block was already overridden by the A4
    // @page above (emotion injects after main.css) and is dropped instead of
    // flipped.
    ".container": {
      width: "1208px",
      padding: 0,
    },
    "#root_headerSelector, .footer-box": {
      display: "none",
    },
    ".scha__pdp": {
      position: "relative",
      paddingTop: "60px",
    },
    ".scha__pdp__product-box": {
      marginTop: "16px",
    },
    ".scha__pdp__print-logo": {
      position: "absolute",
      top: "30px",
      right: 0,
      height: "35px",
      display: "flex",
      alignItems: "center",
    },
    ".scha__pdp__timestamp": {
      position: "absolute",
      top: "30px",
      left: 0,
      height: "35px",
      display: "flex",
      alignItems: "center",
    },
    ".scha__pdp__purchase-card, .scha__pdp__pdf-link, .scha__pdp__specifications-col, .scha__preferred-products, .scha__related-products":
      {
        display: "none",
      },
    ".scha__pdp__image-col, .scha__pdp__techimages-col": {
      width: "33.3333%",
    },
    ".scha__pdp__techdetails-col, .scha__pdp__baseinfo-col": {
      flex: 1,
      left: 0,
    },
    ".scha__data-table": {
      breakInside: "avoid",
    },
    ".scha__pdp__print-disclaimer": {
      display: "block !important",
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
    },
    ".scha__pdp__frequently-bought-together": {
      width: "100vw",
      position: "relative",
      left: "50%",
      right: "50%",
      marginLeft: "-50vw",
      marginRight: "-50vw",
    },
    ".scha__pdp #tabs": {
      minHeight: "unset",
      display: "contents",
      "& .MuiTab-root.Mui-selected": {
        ...theme.typography.titleMedium,
        color: theme.palette.text.primary,
        fontWeight: "normal",
      },
      "& .MuiTabs-root, & .MuiTabs-scroller, & .MuiTabs-flexContainer, & .MuiTab-root.Mui-selected": {
        display: "contents",
      },
      "&:before, & .MuiTab-root:not(.Mui-selected), & .MuiTabs-indicator": {
        display: "none",
      },
    },
  },
});

export const PrintGlobalStyles = () => <MuiGlobalStyles styles={printStyles} />;
